import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "evaluation" }
const _hoisted_2 = {
  key: 0,
  class: "evaluation-title"
}
const _hoisted_3 = { class: "infos" }
const _hoisted_4 = { class: "code" }
const _hoisted_5 = {
  key: 0,
  class: "company"
}
const _hoisted_6 = {
  key: 1,
  class: "evaluation-tab"
}
const _hoisted_7 = { class: "title" }
const _hoisted_8 = {
  key: 0,
  class: "actions"
}
const _hoisted_9 = { class: "evaluation-content" }

import { computed, onMounted, ref, Component } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

import type {
  EvaluationType,
  EvaluationListType,
} from "@/common/types/evaluation";

import { MobileMenuTheme } from "../";

import { baseAvatar, svgIcon } from "@/common/components";

interface TabListType {
  [key: string]: {
    key: string;
    icon: string;
    label: string;
    component: Component;
  };
}


export default /*@__PURE__*/_defineComponent({
  __name: 'evaluation',
  props: {
    accountId: {},
    evaluationId: {},
    evaluation: {},
    evaluations: {},
    tabList: {},
    menuList: {},
    isEdit: { type: Boolean }
  },
  emits: [
  "update-data",
  "add",
  "input-search",
  "search",
  "select-tab",
],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();
const router = useRouter();

const emit = __emit;

const props = __props;

const selectedTab = ref<string | null>(null);
const selectedCode = ref<string | null>(null);

const tab = computed(() => {
  if (!selectedTab.value) return null;

  return props.tabList[selectedTab.value as string] || null;
});

function selectTab(tab: string) {
  selectedTab.value = tab;
}

function closeSelected() {
  const tab = selectedTab.value as string;
  selectedCode.value = null;
  selectTab("");
  setTimeout(() => selectTab(tab), 25);
}

function limitText(text: string) {
  if (text.length > 25) {
    return text.substring(0, 25) + "...";
  }
  return text;
}

onMounted(() => {
  selectTab("info");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(MobileMenuTheme), {
    "menu-list": props.menuList,
    "tab-active": selectedTab.value,
    "account-id": props.accountId,
    "show-home": false,
    "show-back": true,
    "back-url": `/${props.accountId}/evaluate`,
    "content-padding": "0",
    onOpenMenu: selectTab
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (__props.evaluation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_unref(baseAvatar), {
                size: '2rem',
                url: __props.evaluation.company?.avatar?.small
              }, null, 8, ["url"]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(__props.evaluation.code), 1),
                (__props.evaluation.company)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(limitText(__props.evaluation.company?.name)), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (tab.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_unref(svgIcon), {
                  icon: tab.value.icon,
                  size: "2rem"
                }, null, 8, ["icon"]),
                _createTextVNode(" " + _toDisplayString(tab.value.label) + " ", 1),
                (selectedCode.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" - " + _toDisplayString(selectedCode.value), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              (selectedCode.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("button", {
                      class: "btn btn-back btn-sm",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (closeSelected()))
                    }, [
                      _createVNode(_unref(svgIcon), {
                        icon: "close",
                        size: "1.25rem"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          (selectedTab.value)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(__props.tabList[selectedTab.value]?.component), {
                key: 0,
                "is-edit": __props.isEdit,
                "account-id": __props.accountId,
                "evaluation-id": __props.evaluation?.evaluation_id,
                data: __props.evaluation,
                "show-title": false,
                onUpdateData: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update-data'))),
                onSelectedCode: _cache[2] || (_cache[2] = ($event: any) => (selectedCode.value = $event))
              }, null, 40, ["is-edit", "account-id", "evaluation-id", "data"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["menu-list", "tab-active", "account-id", "back-url"]))
}
}

})